import { SectionTitle, CmpTable } from "../../shared";
import SubComponent from "./SubComponent";
import { GET_ABBVIE_ID_CONFIGURED_APP_LIST } from "./query";

const ConfiguredAppList = () => {
    const columns = [
        {
            id: "configuredApps",
            accessorKey: "appName",
            header: "App Name",
        },
        {
            accessorKey: "aemAppEnvironmentPath",
            header: "AEM App Environment Path",
        },
    ];

    const renderSubComponent = (data) => <SubComponent data={data.row.original} />;

    return (
        <>
            <SectionTitle
                title="AbbVie ID Configured App"
                buttonUrl="/global-config/abbvie-id/app-list/create"
                backUrl="/global-config/abbvie-id"
            />

            <CmpTable
                QUERY={GET_ABBVIE_ID_CONFIGURED_APP_LIST}
                headers={columns}
                renderSubComponent={renderSubComponent}
                dataPath="allIccAppConfigurations"
            />
        </>
    );
};

export default ConfiguredAppList;
